const addDotToThirdPosition = (text, index) => {
  let str = text;
  if (str.length >= 3) {
    if (str.charAt(index) !== "·") {
      str = str.slice(0, index) + "·" + str.slice(index);
    }
  }
  return str;
};

const getScore = (orderStatistics) => {
  //计算分数

  if (!orderStatistics) {
    return 5;
  }
  Object.keys(orderStatistics).forEach(function (key) {
    orderStatistics[key] = orderStatistics[key] * 1;
  });
  if (orderStatistics.orderCompleteNum == 0) {
    return orderStatistics.overallRate;
  } else {
    let num =
      (orderStatistics.overallRate - 5) / orderStatistics.orderCompleteNum;
    return Math.round(num * 10) / 10;
  }
};

const hideMiddleFour = (phoneNumber) => {
  if (phoneNumber && phoneNumber.length === 11) {
    // 确保手机号是11位
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  }
  return phoneNumber; // 如果不是有效的11位手机号，则原样返回
};
const findData = (list, id, key1, key2) => {
  if (!list || !id) return "";
  let companyItem = list.find((item) => item[key1] == id);
  return companyItem ? companyItem[key2] : "";
};
const mergeObj = (obj1, obj2) => {
  Object.keys(obj2).forEach((key) => {
    if (obj1.hasOwnProperty(key)) {
      // 检查obj1是否有这个属性
      obj1[key] = obj2[key]; // 如果有，就将obj2的值赋给obj1
    }
  });
  return obj1;
};
const getDate = (time) => {
  let parsedTime;
  if (time) {
    parsedTime = new Date(time);
    if (isNaN(parsedTime.getTime())) {
      // 验证日期
      console.warn("提供的无效时间值。回退到当前日期。");
      parsedTime = new Date(); // 回退到当前日期
    }
  } else {
    parsedTime = new Date(); // 默认为当前日期
  }

  let year = parsedTime.getFullYear();
  let month = parsedTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = parsedTime.getDate();
  day = day < 10 ? "0" + day : day;
  let hour = parsedTime.getHours();
  hour = hour < 10 ? "0" + hour : hour;
  let minute = parsedTime.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  let second = parsedTime.getSeconds();
  second = second < 10 ? "0" + second : second;

  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
  );
};
//设置表格第一行的颜色
const getRowClass = ({ row, column, rowIndex, columnIndex }) => {
  if (rowIndex == 0) {
    return "background:#EEEEEE ;color:#666666";
  } else {
    return "";
  }
};
//设置表格第一行的颜色
const convertDateStringToDate = (dateString) => {
  if (!dateString || dateString.length !== 8) {
    console.warn("提供的日期字符串无效或格式不正确。回退到当前日期。");
    return new Date().toISOString().split("T")[0]; // 回退到当前日期
  }

  const year = parseInt(dateString.slice(0, 4), 10);
  const month = parseInt(dateString.slice(4, 6), 10) - 1;
  const day = parseInt(dateString.slice(6, 8), 10);

  const date = new Date(year, month, day);
  if (isNaN(date.getTime())) {
    console.warn("提供的日期字符串无法解析为有效日期。回退到当前日期。");
    return new Date().toISOString().split("T")[0]; // 回退到当前日期
  }

  return date.toISOString().split("T")[0];
};

export {
  addDotToThirdPosition,
  getScore,
  hideMiddleFour,
  findData,
  mergeObj,
  getDate,
  getRowClass,
  convertDateStringToDate,
};
